"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _ChevronRight = _interopRequireDefault(require("@insided/shared/icons/ChevronRight"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var CategoryListItem = function CategoryListItem(_ref) {
  var className = _ref.className,
      title = _ref.title,
      selectedCategory = _ref.selectedCategory,
      onSelect = _ref.onSelect,
      childCategories = _ref.childCategories,
      id = _ref.id,
      isContainer = _ref.isContainer,
      isCollapsed = _ref.isCollapsed;
  return (0, _preact.h)("div", null, (0, _preact.h)("li", {
    className: (0, _classnames.default)(className, isContainer ? 'category-filter--container' : 'category-filter--content', isContainer && id && 'category-filter--collapsible', id === selectedCategory && 'category-filter--selected'),
    onClick: function onClick() {
      return onSelect(id, isContainer);
    },
    onKeyUp: function onKeyUp(e) {
      return e.code === 'Enter' ? onSelect(id, isContainer) : null;
    },
    role: "button",
    tabIndex: 0
  }, id && isContainer && (isCollapsed ? (0, _preact.h)(_ChevronRight.default, null) : (0, _preact.h)(_ChevronDown.default, null)), !id ? (0, _preact.h)(_phrase.default, {
    p: "all.categories"
  }) : (0, _preact.h)("span", null, title)), childCategories && (0, _preact.h)("ul", {
    className: (0, _classnames.default)('category-filter__list', isCollapsed && 'category-filter--collapsed')
  }, childCategories.map(function (_ref2, index) {
    var title = _ref2.title,
        id = _ref2.id,
        isContainer = _ref2.isContainer,
        isCollapsed = _ref2.isCollapsed;
    return (0, _preact.h)(CategoryListItem, {
      id: String(id),
      isCollapsed: isCollapsed,
      isContainer: isContainer,
      key: index,
      onSelect: onSelect,
      selectedCategory: selectedCategory,
      title: title
    });
  })));
};

var _default = CategoryListItem;
exports.default = _default;